module.exports = __webpack_public_path__ + "static/img/HK.acdcc85c.png";